<template>
  <v-main>
    <a-header />
    <p-form
      ref="dataform"
      caption="Personel"
      :actions="formActions"
      :models="models"
      :autoCloseAfter="true"
      :refreshHook="refreshDataGrid"
      :defaultValues="{ status: true }"
    >
      <template slot="content">
        <v-container fluid>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="models.id"
                label="ID"
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                dense
                label="Durum"
                v-model="models.status"
                :items="[
                  { value: false, text: 'Pasif' },
                  { value: true, text: 'Aktif' },
                ]"
                :rules="validation().required().toRules('Durum')"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="models.staff_group"
                label="Grup"
                :rules="validation().required().toRules('Grup')"
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="models.staff_class"
                label="Sınıf"
                :rules="validation().required().toRules('Sınıf')"
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <p-lookup
                v-model="models.staff_type"
                label="Tip"
                :rules="validation().required().toRules('Tip')"
                :fetchOptions="{ method: 'post' }"
                fetch="/lookup/staffTypes"
                responseManipulator="data"
                :responseData="{ text: 'staff_type', value: 'staff_type' }"
                dense
              ></p-lookup>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </p-form>
    <p-datagrid
      ref="datagridInstance"
      :url="gridUrl"
      :selectable="gridSelectable"
      :uniqueColumn="gridUniqueColumn"
      :headers="gridHeaders"
      :exportable="gridExportable"
      :clearable="gridClearable"
      :filters="gridFilters"
      :rowActions="gridRowActions"
      :massActions="gridMassActions"
      :actions="gridActions"
      :searchable="gridSearchable"
      :icon="gridIcon"
      :caption="gridCaption"
    />
    <a-footer />
  </v-main>
</template>

<script>
export default {
  name: "staff-type",
  components: {},
  data: (vm) => ({
    inEdit: false,
    gridUrl: "/setup/typeOfStaffList",
    gridClearable: true,
    gridSearchable: true,
    gridSelectable: false,
    gridExportable: true,
    gridUniqueColumn: "id",
    gridIcon: "face",
    gridCaption: "Personel Tipleri",
    gridHeaders: [
      {
        text: "İşlemler",
        value: "action",
        sortable: false,
        unExportable: true,
      },
      { text: "ID", value: "id", align: "center", sortable: true },
      { text: "Grup", value: "staff_group", sortable: true },
      { text: "Sınıf", value: "staff_class", sortable: true },
      { text: "Tip", value: "staff_type", sortable: true },
      {
        text: "Durum",
        value: "status",
        sortable: false,
        callable(item) {
          return item.status ? "Aktif" : "Pasif";
        },
        format: (item) => {
          return item.status ? "green--text" : "red--text";
        },
      },
    ],
    gridFilters: [
      {
        type: "text",
        name: "staff_group",
        label: "Grup",
      },
      {
        type: "text",
        name: "staff_class",
        label: "Sınıf",
      },
      {
        type: "select",
        name: "staff_type",
        label: "Tip",
        lookups: vm.getStafftypeLookups(),
      },
      {
        type: "select",
        name: "status",
        label: "Durum",
        lookups: [
          { value: true, text: "Aktif" },
          { value: false, text: "Pasif" },
        ],
      },
    ],
    gridMassActions: [],
    gridRowActions: [
      {
        icon: "edit",
        hint: "Düzenle",
        color: "blue",
        action: (item) => {
          vm.inEdit = true;
          vm.$refs.dataform.showFetch(item, "edit", "Düzenle");
        },
      },
      {
        icon: "delete",
        hint: "Sil",
        color: "red",
        warn: true,
        action: async (item, self) => {
          try {
            await vm.axios.delete("/setup/typeOfStaff/" + encodeURI(item.id));
            vm.$refs.datagridInstance.refresh();
          } catch (error) {
            vm.$dialog.error({ text: this.utils.getErrorMessage(error) });
          }
        },
        guard: (item, self) => {
          return true;
        },
      },
    ],
    gridActions: [
      {
        action: () => {
          vm.inEdit = false;
          vm.$refs.dataform.show("Ekle");
        },
      },
    ],
    //END OF DATAGRID

    //FORM
    models: {
      id: null,
      staff_group: null,
      staff_class: null,
      staff_type: null,
      status: null,
    },
    formActions: [
      {
        text: "Kaydet",
        api: {
          url: `/setup/createTypeOfStaff`,
          method: "put",
        },
        condition: null,
      },
      {
        text: "Güncelle",
        fetch: {
          url: "/setup/typeOfStaff/",
          id: "id",
        },
        api: {
          url: "/setup/updateTypeOfStaff",
          method: "patch",
        },
        condition: "edit",
      },
    ],
  }),
  computed: {},
  watch: {},
  methods: {
    getStafftypeLookups() {
      let ret = [];
      this.axios.post("/lookup/staffTypes").then((res) => {
        for (let i in res.data.data) {
          let c = res.data.data[i];        
          ret.push({ value: c.staff_type, text: c.staff_type });
        }
        this.$refs &&
          this.$refs.datagridInstance &&
          this.$refs.datagridInstance.redraw();
      });

      return ret;
    },
    refreshDataGrid() {
      this.$refs.datagridInstance.refresh();
    },
  },
  async mounted() {},
  created() {},
};
</script>